import MembershipBusinessListModelBase from '../_generated/modelBases/membership-business-list-model-base';

export default class MembershipBusinessListModel extends MembershipBusinessListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
